import { hotRank } from "@/mocks/guaData";

function rankCls(i: number) {
  if (i === 0) return "bg-primary-500 text-background-50";
  if (i === 1) return "bg-accent-500 text-background-50";
  if (i === 2) return "bg-secondary-500 text-background-50";
  return "bg-secondary-100 text-foreground-500";
}

export default function HotRank() {
  return (
    <section id="hot-rank" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12">
        {/* 左侧榜单 */}
        <div>
          <p className="mb-1.5 text-xs font-bold uppercase tracking-widest text-accent-700">Hot List · 热度爬升中</p>
          <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            热瓜有哪些，榜单见真章
          </h2>
          <div className="mt-6 flex flex-col">
            {hotRank.map((item, i) => (
              <a
                key={item.title}
                href="#live-feed"
                className="group flex cursor-pointer items-start gap-3 border-b border-background-200/60 py-3.5 transition hover:bg-background-100/80"
              >
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${rankCls(i)}`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 text-sm font-medium leading-relaxed text-foreground-900 group-hover:text-primary-700 md:text-[15px]">
                  {item.title}
                </span>
                <span className="mt-1 hidden shrink-0 items-center gap-1 text-xs font-semibold text-foreground-400 sm:inline-flex">
                  <i className="ri-fire-fill text-accent-500" />
                  {item.heat.toFixed(1)}
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* 右侧吃瓜姿势提示卡 */}
        <aside className="flex flex-col gap-4">
          <div className="flex-1 rounded-lg border border-background-200/70 bg-background-50 p-6">
            <span className="inline-flex items-center gap-2 text-sm font-bold text-foreground-950">
              <i className="ri-goblet-fill text-primary-500" />
              吃瓜姿势说明书
            </span>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              热度高 ≠ 瓜是真。挤在热瓜榜前排的，一半是实锤，一半是剧本。
            </p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />先找一手信源，再谈吃还是吐</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />截图可P，实拍才值得多看一眼</li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-500" />让子弹飞一会儿，别急着站队</li>
            </ul>
            <a
              href="#comment-talk"
              className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-accent-300 bg-accent-50 px-4 py-2 text-sm font-semibold text-accent-800 transition hover:bg-accent-100"
            >
              围观评论区风向 <i className="ri-arrow-right-s-line" />
            </a>
          </div>
          <div className="rounded-lg bg-foreground-950 p-6 text-background-50">
            <p className="text-sm font-semibold">一句吃瓜m的碎碎念</p>
            <p className="mt-2 text-sm leading-relaxed text-background-200">
              “热瓜有哪些”刷到眼花时，记得把瓜切开看看瓤熟不熟。
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}